import React from "react"
import { useLocalization } from "../src/hooks/useLocaleFormatter"
import { DocumentFragment } from "../src/model/fragments"
import { zipDownloadProxy } from "../src/utils/zipDownloadProxy"
import { CardDownload } from "./CardDownload"
import { mimeTypeToFileExtension } from "../src/utils/mimeTypeToFileExtension"
import { formatFilesize } from "../src/utils/formatFilesize"

export interface CardDocumentProps {
    item: DocumentFragment,
    forcedTitle?: string
}

export const CardDocument: React.FunctionComponent<CardDocumentProps> = ({
    item,
    forcedTitle
}) => {
    const localization = useLocalization()

    const data = React.useMemo(() =>  localization.extractLocale(item.locales), [item]);
    if (!data?.file) {
        return <></>
    }

    const extension = React.useMemo(() => {
        return mimeTypeToFileExtension(data?.file?.type || '')
    }, [item, data])

    const suffix = React.useMemo(() => {
        const size = data.file.size ? formatFilesize(data.file.size) : undefined;
        return `${extension} ${size ? '' + size : ''}`; 
    }, [data, extension])

    return <CardDownload
        className="cardDocument"
        extension={extension}
        title={forcedTitle ?? data.name}
        href={
            data.file.type === 'application/x-zip-compressed'
                ? zipDownloadProxy(data.file.id, data.file.name)
                : data.file.url
        }
        suffix={suffix}
        imageIcon={item.ownIcon}
    />
}
